export default __webpack_public_path__ + "locales/sr-Latn-RS/PaymentsEnterprise.json?hash=e6f23c581a5795bc2aa1ecb224f8df6b";